import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const getInitialTempEmail = () => {
	const email = Cookies.get("E_tempEmail");
	return email && email !== "undefined" && email !== "null" ? email : "";
};

const initialState = {
	tempEmail: getInitialTempEmail(),
	share: {
		show: false,
		endPoint: "",
		id: "",
	},
	postReload: false,
	pollObj: {
		enablePoll: false,
		pollKeys: [],
		enableCustomPoll: false,
		customPollPopupShow: false,
	},
	selectedCategory: null,
	selectedSubCategory: null,
	selectedNestedCategory: null,
};

const tempSlice = createSlice({
	name: "tempSlice",
	initialState,
	reducers: {
		setTempEmail: (state, { payload }) => {
			state.tempEmail = payload;
			if (payload) {
				Cookies.set("E_tempEmail", payload);
			} else {
				Cookies.remove("E_tempEmail");
			}
		},

		setShareData: (state, { payload }) => {
			state.share = payload;
		},

		setPostReload: (state, { payload }) => {
			state.postReload = payload;
		},

		setPollEnable: (state, { payload }) => {
			state.pollObj.enablePoll = payload;
		},

		setCustomPollShow: (state, { payload: { enableCustomPoll, customPollPopupShow } }) => {
			state.pollObj.enableCustomPoll = enableCustomPoll;
			state.pollObj.customPollPopupShow = customPollPopupShow;
		},

		setCustomPollKey: (state, { payload }) => {
			state.pollObj.pollKeys = payload;
		},
		setSelectedCategory: (state, { payload }) => {
			state.selectedCategory = payload.category;
			state.selectedSubCategory = payload.subCategory || null;
			state.selectedNestedCategory = payload.nestedCategory || null;
		},
	},
});

export const { setTempEmail, setShareData, setPostReload, setPollEnable, setCustomPollShow, setCustomPollKey, setSelectedCategory } =
	tempSlice.actions;
export default tempSlice.reducer;


